import { fetchAPI, METHODS } from './common';
import qs from 'qs';

/**
 * Update the driver's availability hours.
 * @param {object} weekTimesObj
 */
export async function updateDriverAvailability(weekTimesObj) {
  const response = await fetchAPI('/driver/availability', METHODS.put, {
    weekTimesObj,
  });
  return response.json();
}

/**
 * Get the driver's availability hours.
 */
export async function getDriverAvailability() {
  const response = await fetchAPI('/driver/availability', METHODS.get);
  return response.json();
}

/**
 * Get all available drivers for a team at a specific pickup time.
 * @param {string} teamId - The ID of the team
 * @param {string} pickupTime - The pickup time to check availability for
 * @param {string} [endTime] - Optional end time for the donation
 * @param {string} occurenceType - onetime, recurring or indefinite
 * @param {string} interval - The interval for the recurring donation
 * @param {Array} daysOfTheWeek - Array of days of the week for the weekly recurring donation. Starts with 0 for Sunday
 * @returns {Promise<Array>} - Array of driver objects with availability information
 */
export const getAvailableDriversForTeam = async ({
  pickupTime,
  endTime,
  occurrenceType,
  interval,
  daysOfTheWeek,
  dayOfTheMonth,
}) => {
  const query = {
    pickupTime,
    endTime,
    occurrenceType,
    interval,
    daysOfTheWeek,
    dayOfTheMonth,
  };
  let url = `/driver/team/available?${qs.stringify(query, {
    skipNulls: true,
  })}`;

  const response = await fetchAPI(url, METHODS.get);
  return response.json();
};
